// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Company } from './company';
import { ContactPerson } from './contact-person';
import { Employee } from './employee';
import { User } from './user';

/**
 * 
 * @export
 * @interface JuridicalContractorNew
 */
export interface JuridicalContractorNew {
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    shortTitle: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    inn: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    legalAddress: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    factAddress: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    site?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    kpp: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    ogrn: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    paymentAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    correspondentAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    bank?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    bik?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    okpo?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    okato?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    okved?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    directorName?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    directorNameInitials?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    directorNameGenitive?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    directorPosition?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    directorPositionGenitive?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    basis: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    type?: string;
    /**
     * 
     * @type {User}
     * @memberof JuridicalContractorNew
     */
    user?: User;
    /**
     * 
     * @type {Company}
     * @memberof JuridicalContractorNew
     */
    company: Company;
    /**
     * 
     * @type {Employee}
     * @memberof JuridicalContractorNew
     */
    responsible?: Employee;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof JuridicalContractorNew
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof JuridicalContractorNew
     */
    updatedAt?: Date;
    /**
     * 
     * @type {ContactPerson}
     * @memberof JuridicalContractorNew
     */
    contactPerson?: ContactPerson;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JuridicalContractorNew
     */
    studentIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorNew
     */
    objectType: JuridicalContractorNewObjectTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum JuridicalContractorNewObjectTypeEnum {
    PhysicalContractorNew = 'PhysicalContractorNew',
    JuridicalContractorNew = 'JuridicalContractorNew'
}



